const DB_NAME = "QuantResearchToolHubOneDriveDB";
const DB_VERSION = 2;
const LEGACY_CLOUD_CACHE_STORE = "cloudCache";
const ASSET_CACHE_STORE = "assetCache";
const LOCAL_STORE = "localFiles";
const SETTINGS_STORE = "settings";

let dbPromise;

function requestPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export function openDatabase() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = event => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(LEGACY_CLOUD_CACHE_STORE)) {
        const store = db.createObjectStore(LEGACY_CLOUD_CACHE_STORE, { keyPath: "key" });
        store.createIndex("accountKey", "accountKey", { unique: false });
        store.createIndex("itemId", "itemId", { unique: false });
      }
      if (!db.objectStoreNames.contains(ASSET_CACHE_STORE)) {
        const store = db.createObjectStore(ASSET_CACHE_STORE, { keyPath: "assetId" });
        store.createIndex("contentHash", "contentHash", { unique: false });
        store.createIndex("cachedAt", "cachedAt", { unique: false });
      }
      if (!db.objectStoreNames.contains(LOCAL_STORE)) {
        const store = db.createObjectStore(LOCAL_STORE, { keyPath: "id" });
        store.createIndex("modifiedAt", "modifiedAt", { unique: false });
      }
      const localStore = request.transaction.objectStore(LOCAL_STORE);
      if (!localStore.indexNames.contains("assetId")) localStore.createIndex("assetId", "assetId", { unique: false });
      if (!localStore.indexNames.contains("contentHash")) localStore.createIndex("contentHash", "contentHash", { unique: false });
      if (!db.objectStoreNames.contains(SETTINGS_STORE)) {
        db.createObjectStore(SETTINGS_STORE, { keyPath: "key" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  return dbPromise;
}

async function store(name, mode = "readonly") {
  const db = await openDatabase();
  return db.transaction(name, mode).objectStore(name);
}

export async function getAllLegacyCloudCache() {
  return requestPromise((await store(LEGACY_CLOUD_CACHE_STORE)).getAll());
}

export async function clearLegacyCloudCache() {
  return requestPromise((await store(LEGACY_CLOUD_CACHE_STORE, "readwrite")).clear());
}

export async function getAllAssetCache() {
  return requestPromise((await store(ASSET_CACHE_STORE)).getAll());
}

export async function getAssetCache(assetId) {
  return requestPromise((await store(ASSET_CACHE_STORE)).get(assetId));
}

export async function putAssetCache({ assetId, contentHash = "", name, mime, blob }) {
  const record = {
    assetId,
    contentHash,
    name,
    mime: mime || blob.type || "application/octet-stream",
    size: blob.size,
    cachedAt: new Date().toISOString(),
    blob
  };
  await requestPromise((await store(ASSET_CACHE_STORE, "readwrite")).put(record));
  return record;
}

export async function deleteAssetCache(assetId) {
  return requestPromise((await store(ASSET_CACHE_STORE, "readwrite")).delete(assetId));
}

export async function getAllLocalFiles() {
  return requestPromise((await store(LOCAL_STORE)).getAll());
}

export async function getLocalFile(id) {
  return requestPromise((await store(LOCAL_STORE)).get(id));
}

export async function putLocalFile(record) {
  await requestPromise((await store(LOCAL_STORE, "readwrite")).put(record));
  return record;
}

export async function deleteLocalFile(id) {
  return requestPromise((await store(LOCAL_STORE, "readwrite")).delete(id));
}

export async function getSetting(key) {
  const row = await requestPromise((await store(SETTINGS_STORE)).get(key));
  return row?.value;
}

export async function putSetting(key, value) {
  await requestPromise((await store(SETTINGS_STORE, "readwrite")).put({ key, value }));
}
